import { Common } from '../common';

import {
  ChatMessageType,
  Conversion,
  Feedback,
  Filters,
  Platform,
  Query,
  Satisfaction,
} from '../models/report/feedback';
import { AgeGroup, IncomeGroup, MaritalStatus } from '../models/common';
import { FeedbackType } from '../models/feedback';
import { Ethnicity, Race, Sex } from '../models/patient';

export class API {
  common: Common;
  BASE_URL = `/analytics/previsit-geospatial-conversion`;

  constructor(common: Common) {
    this.common = common;
  }

  async chatCompletion(
    messages: ChatMessageType[],
  ): Promise<{ answer: string }> {
    const url = this.common.constructPath(`${this.BASE_URL}/chat-completion`);
    return this.common.postJSON(url, { messages });
  }

  async getFeedback(query: Query): Promise<Feedback[]> {
    const url = this.common.constructPath(
      `${this.BASE_URL}/feedback`,
      constructQuery(query),
    );
    const { data } = await this.common.getJSON(url);
    return data;
  }

  async getSatisfaction(query: Query): Promise<Satisfaction[]> {
    const url = this.common.constructPath(
      `${this.BASE_URL}/feedback-daily-counts`,
      constructQuery(query),
    );
    const { data } = await this.common.getJSON(url);
    return data;
  }

  async getConversion(query: Query): Promise<Conversion[]> {
    const url = this.common.constructPath(
      `${this.BASE_URL}/intake-completion-daily-counts`,
      constructQuery(query),
    );
    const { data } = await this.common.getJSON(url);
    return data;
  }
}

function constructQuery(query: Query) {
  return {
    startDate: query.startDate,
    endDate: query.endDate,
    ...constructFilterToQuery(query.filters),
  };
}

function normalize(value: string) {
  return value.toUpperCase();
}

function constructFilterToQuery(filters: Filters) {
  const filtersToAdd = new Set(
    Object.entries(filters)
      .filter(([key, value]) => value)
      .map(([key, value]) => normalize(key)),
  );
  function enumFilter(enumObj: object) {
    return Object.entries(enumObj)
      .filter(([key, value]) =>
        filtersToAdd.has(normalize(key).replace(/[^A-Za-z0-9]/g, '')),
      )
      .map(([key, value]) => value);
  }
  return {
    ageGroup: enumFilter(AgeGroup),
    gender: enumFilter(Sex),
    hispanicOrLatino: enumFilter(Ethnicity),
    incomeGroup: enumFilter(IncomeGroup),
    maritalStatus: enumFilter(MaritalStatus),
    platform: enumFilter(Platform),
    race: enumFilter(Race),
    sentiment: enumFilter(FeedbackType),
    organizationName: filters.organizationName,
  };
}
